<dev-together-auth-wrapper>
  <p paragraph routerLink="/register">No account?</p>

  <button
    dev-together-button-retro
    text="Login"
    insideColor="#f04f65"
    hoverColor="#2acdc1"
    [loading]="status$ | async"
    (click)="submit()"
  ></button>
</dev-together-auth-wrapper>
